import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError,
} from './../feedingGuidelinesBodyConditionAction';
import fetchApi from "./fetchApi";

function fetchFeedingGuidelinesBodyConditionAction() {
  return fetchApi('/v1/fc_api/feeding_guidelines_body_condition_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchFeedingGuidelinesBodyConditionAction;
